"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as o } from "react";
import a from "../components/Icon/SvgIcon.js";
const h = (e) => /* @__PURE__ */ l(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 3.875a2.125 2.125 0 0 0-2.031 1.5H3.75a.625.625 0 1 0 0 1.25h3.219a2.125 2.125 0 0 0 4.062 0h9.219a.625.625 0 1 0 0-1.25h-9.219A2.125 2.125 0 0 0 9 3.875m6 6a2.125 2.125 0 0 0-2.031 1.5H3.75a.625.625 0 1 0 0 1.25h9.219a2.124 2.124 0 0 0 4.062 0h3.219a.625.625 0 1 0 0-1.25h-3.219A2.12 2.12 0 0 0 15 9.875m-6 6a2.125 2.125 0 0 0-2.031 1.5H3.75a.625.625 0 1 0 0 1.25h3.219a2.125 2.125 0 0 0 4.062 0h9.219a.625.625 0 1 0 0-1.25h-9.219A2.12 2.12 0 0 0 9 15.875",
        clipRule: "evenodd"
      }
    )
  }
), m = o(h);
export {
  m as FilterFilled,
  m as default
};
